import { enumAvailableLanguages } from "../models/SettingsEnums";
import { noItx } from "../translationItx/itx";

export default async function aviliableLanguages(): Promise<Array<enumAvailableLanguages>> {
  let res = new Set<enumAvailableLanguages>();
  /// check here if file is availiable

  for (let item in enumAvailableLanguages) {
    /// check here if file is availiable
    try {
      const response = await fetch(
        `${import.meta.env.BASE_URL}locales/${getShort(item)}/translation.json`,
      ).catch(() => undefined);

      const json = response?.ok ? await response.json() : undefined;
      console.log("itx data loaded");
      if (json) {
        res.add(getEnumAvailableLanguageFromString(item));
      }
    } catch (ex) {
      // not found
    }
  }
  return [...res];
}
function getShort(value: string): string {
  switch (value) {
    case noItx("german"): {
      return "de";
    }
    case noItx("spanish"): {
      return "es"; // no itx
    }
    case noItx("french"): {
      return "fr"; // no itx
    }
    case noItx("italian"): {
      return "it"; // no itx
    }
    case noItx("swedish"): {
      return "sv"; // no itx
    }
    case noItx("english"): {
      return "en";
    }
    default: {
      return value.substring(0, 2);
    }
  }
}
export function getEnumAvailableLanguageFromString(vr: string): enumAvailableLanguages {
  switch (vr) {
    case enumAvailableLanguages.german:
    case noItx("german"): {
      return enumAvailableLanguages.german;
    }
    case enumAvailableLanguages.spanish:
    case noItx("spanish"): {
      return enumAvailableLanguages.spanish;
    }
    case enumAvailableLanguages.french:
    case noItx("french"): {
      return enumAvailableLanguages.french;
    }
    case enumAvailableLanguages.italian:
    case noItx("italian"): {
      return enumAvailableLanguages.italian;
    }
    case enumAvailableLanguages.swedish:
    case noItx("swedish"): {
      return enumAvailableLanguages.swedish;
    }
    case enumAvailableLanguages.english:
    case noItx("english"):
    default: {
      return enumAvailableLanguages.english;
    }
  }
}

export function initAvailiableLanguages() {
  aviliableLanguages().then((value) => {
    state.availiableLanguages = value;
  });
}
